import { LoginContext } from "@/providers/LoginProvider";
import { useContext } from "react";

export function useLogin() {
  const context = useContext(LoginContext);
  if (context === undefined) {
    throw new Error("useLogin must be used within a LoginProvider");
  }
  return context;
}
